/**
 * @description Класс отвечает за логику работы кнопки пассажира в мобильном варианте
 * */
class PassengerFormToggle {
    class = {
        active: "is-active"
    };
    selectors = {
        title: ".js-title",
        description: ".js-description"
    };

    constructor($toggle, options) {
        const that = this;

        // DOM
        that.$toggle = $toggle;
        that.$toggle_title = that.$toggle.find(that.selectors.title);
        that.$toggle_description = that.$toggle.find(that.selectors.description);

        //
        that.locales = options.locales;

        //
        that.onClick = (typeof options["onClick"] === "function" ? options["onClick"] : function() {});

        // Dynamic vars
        that.data = (typeof options.data !== "undefined" ? options.data : null);
        that.is_active = false;

        // Init
        that.init();
    }

    init() {
        const that = this;

        // Инициализация клика по кнопке
        that.$toggle.on("click", function(event) {
            event.preventDefault();
            that.onClick();
        });

        that.set(that.data);

        that.$toggle.data("passenger_form_toggle", that);
    }

    /**
     * @description форматируем значения и рендерим кнопку
     * @param {Object} data
     * */
    set(data) {
        const that = this;

        const formatted_data = that.#formatData(data),
              active_class = that.class.active;

        // Рендер
        if (formatted_data) {
            that.$toggle_title.text(formatted_data.title);
            that.$toggle_description.text(formatted_data.description);
            that.$toggle.addClass(active_class);

            that.is_active = true;
            that.data = formatted_data;

        } else {
            that.$toggle.removeClass(active_class);
            that.$toggle_title.html("");
            that.$toggle_description.html("");

            that.is_active = false;
            that.data = null;
        }
    };

    /**
     * @description Форматирует данные в текстовый вид
     * @param {Object} data
     * @returns {?Object}
     * */
    #formatData(data) {
        const that = this;

        let result = null;

        if (data) {
            let title = [],
                description = [];

            const name_mask = ["lastname", "firstname", "middlename"],
                  desc_mask = ["sex", "nationality", "birthdate", "doc_code", "doc_number"];

            name_mask.forEach( function(name_item) {
                const value = data[name_item];
                if (value) {
                    title.push(value);
                }
            });

            desc_mask.forEach( function(desc_item) {
                let value = data[desc_item];
                if (value) {
                    switch (desc_item) {
                        case "sex":
                            value = that.locales["sex"][value];
                            break;
                        case "nationality":
                            value = that.locales["countries"][value];
                            break;
                        case "doc_code":
                            value = that.locales["document_codes"][value];
                            break;
                    }

                    description.push(value);
                }
            });

            if (title.length) {
                result = {
                    title: title.join(" "),
                    description: description.join(", ")
                };
            }
        }

        return result;
    }
}